import React, { FunctionComponent } from 'react'
import { ProductInfo, ProductInfoData } from '../components/product-info'
import { ProductPageOuter } from '../components/product-page-components'
import { ProductStepSection, ProductStepSectionData } from '../sections/product-step-section'
import { VerticalSpacer } from '../components/spacer'
import { ProductDetailSection, ProductDetailSectionData } from '../sections/product-detail-section'
import { SetProductsSectionHerbPeelCleansingGel } from '../sections/set-products-section'
import { UseSection2 } from './use-section'
import { LineUpSection } from '../sections/line-up-section'
import { productSku } from '../product-sku'

const productInfoData: ProductInfoData = {
  images: [
    'p9-3.png'
  ],
  brandName: 'SKN REMED',
  name: <>
    HerbPeel Cleansing Gel
  </>,
  nameJa: 'ハーブピールクレンジングジェル',
  info: [
    {
      label: '内容量',
      value: '100g'
    }
  ],
  checkoutNote: <>
  </>,
  singleSku: productSku.herbPeelCleansingGel.single,
  subscriptionSku: productSku.herbPeelCleansingGel.subscription,
  subscriptionNotice: ({originalSingle, single, subscription}) => {
    if(!subscription) return null
    return <>
      ※定期便購入回数のお約束はなく、解約・休止が可能です。<br />
      ※定期便の初回価格は3,060円(税込)、2回目以降は商品2個を6,120円(税込)で発送いたします。<br />
      ※2回目は30日後に、3回目以降は60日毎にお届けいたします。<br />
      ※定期便の解約は、次回商品発送予定日の7日前までにお電話（0120-488-873）、<br />
      または問い合わせフォーム（https://skn-remed.com/shop/contact）にてご連絡下さい。
    </>
  }
}

export const productStepSectionData: ProductStepSectionData = {
  backgroundImg: 'p9-10.png',
  graph: <></>,
  stepColor: '#233C31',
  text1: <>
    HerbPeel Cleansing Gel
  </>,
  text2: <>
    ハーブピール発想で、毛穴汚れや角栓をやわらげながら、クリアな肌印象<sup>※1</sup>へ導く
  </>,
  text3: <>
    AHA（リンゴ酸<sup>※2</sup>）・PHA（グルコノラクトン<sup>※2</sup>）・BHA（サリチル酸<sup>※2</sup>）を配合したピールケアコンプレックスが、古い角質や皮脂汚れにアプローチ。さらに、植物由来の結晶セルロース<sup>※3</sup>が毛穴汚れを絡め取り、4種のハーブエキス<sup>※4</sup>が肌を整えながら、毛穴の目立ちにくいすっきりとした肌へ導きます。
  </>,
  note: <>
    ※1 汚れが落ち、キメの整った肌印象のこと<br />
    ※2 整肌成分 ※3 洗浄成分 ※4 ヨモギ葉エキス、ドクダミエキス、セージ葉エキス、ローズマリー葉エキス（保湿成分）
  </>
}

export const productDetailSectionData: ProductDetailSectionData = {
  img1: 'p9-6.png',
  img2: 'p9-7.png',
  img3: 'p9-8.png',
  img4: 'p9-9.png',
  text1: <>
    欧米で注目の毛穴ケア成分
  </>,
  text2: <>
    欧米で話題の2種類の「アゼライン酸<sup>※1</sup>」と植物由来の「ハーブエキス<sup>※2</sup>」を掛け合わせることで、5大毛穴悩み（詰まり・黒ずみ・目立ち<sup>※3</sup>・乾燥・ハリ不足）へ多角的にアプローチする設計を追求しました。
  </>,
  text3: <>
  </>,
  text4: <>
  </>,
  note1: <>
    ※1 アゼライン酸（整肌成分）、アゼロイルジグリシンＫ（整肌成分）<br />
    ※2 ヨモギ葉エキス、ドクダミエキス、セージ葉エキス、ローズマリー葉エキス（保湿成分）<br />
    ※3 肌のハリ不足による毛穴の目立ち
  </>,
  text5: <>
    6種のビタミン<sup>※1</sup>を内包した「ポアケアカプセル<sup>※2</sup>」配合
  </>,
  text6: <>
    植物由来繊維<sup>※3</sup>を使用した、指先で潰れるカプセルを配合。肌の上でマッサージするようになじませることでカプセルが弾け、内包された6種のビタミン<sup>※1</sup>（ B5、H、B12、A、C、E ）が角質層へ浸透。キメを整え、ピーリング後のようなつるんとなめらかな肌へ導きます。
    <span style={{ display: 'block', fontWeight: 700, marginTop: '2rem', marginBottom: '0.5rem' }}>
      「ハーブピールパック」としても使える2WAY仕様
    </span>
    毛穴汚れや黒ずみが特に気になる部分には、約5分間塗布して洗い流す「ハーブピールパック」としての使用も可能。密着ジェルが肌にフィットし、蓄積した角栓にじっくりアプローチします。
    <span style={{ display: 'block', fontWeight: 700, marginTop: '2rem', marginBottom: '0.5rem' }}>
      肌に澄みわたらせるハーバルシトラスの香り
    </span>
    ローズマリー、ユーカリ、レモングラスの精油をブレンドした、澄みわたるように清々しい自然由来の香り。肌をすっきりと整えながら、1日の終わりのクレンジングタイムを心地よいリセットの時間へ導きます。
  </>,
  note2: <>
    ※1 パンテノール、ビオチン、シアノコバラミン、パルミチン酸レチノール、テトラヘキシルデカン酸アスコルビル、トコフェロール（整肌成分）<br />
    ※2 結晶セルロース、エチルセルロース（洗浄成分）、パンテノール、ビオチン、シアノコバラミン、パルミチン酸レチノール、テトラヘキシルデカン酸アスコルビル、トコフェロール（整肌成分）<br />
    ※3 結晶セルロース（洗浄成分）
  </>
}

type ProductHerbPeelCleansingGelPageProps = {

}
export const ProductHerbPeelCleansingGelPage: FunctionComponent<ProductHerbPeelCleansingGelPageProps> = () => {
  return <ProductPageOuter>
    <ProductInfo
      data={productInfoData}
    />
    <VerticalSpacer length='4rem' />
    <ProductStepSection
      data={productStepSectionData}
    />
    <VerticalSpacer length='8rem' />
    <ProductDetailSection
      data={productDetailSectionData}
    />
    <VerticalSpacer length='8rem' />
    <SetProductsSectionHerbPeelCleansingGel />
    <VerticalSpacer length='8rem' />
    <UseSection2 />
    <VerticalSpacer length='8rem' />
    <ProductInfo
      data={productInfoData}
    />
    <VerticalSpacer length='8rem' mLength='4rem' />
    <LineUpSection />
  </ProductPageOuter>
}
